import Keycloak from 'keycloak-js'
import React, { createContext } from 'react'

export interface KeycloakCurrentUser {
  lastName: string
  name: string
  email: string
  keycloakId: string
}

interface KeycloakContextProps {
  clientUrl?: string
  instance?: Keycloak
  currentUser?: KeycloakCurrentUser
}

export const KeycloakContext = createContext<KeycloakContextProps>({})

interface KeycloakProviderProps {
  clientUrl?: string
  instance?: Keycloak
  children: JSX.Element
}

export interface KeycloakUserInfo {
  family_name: string
  given_name: string
  name: string
  preferred_username: string
  sub: string
}

export const KeycloakProvider = ({ children, clientUrl, instance }: KeycloakProviderProps) => {
  const user = instance?.userInfo as KeycloakUserInfo

  const currentUser: KeycloakCurrentUser = {
    name: user?.name ?? '',
    lastName: user?.family_name ?? '',
    email: user?.preferred_username ?? '',
    keycloakId: user?.sub ?? ''
  }

  return <KeycloakContext.Provider value={{ clientUrl, instance, currentUser }}>{children}</KeycloakContext.Provider>
}
